import * as Types from './types';

export const BALANCES_NAMES: Record<string, Types.TBalanceType> = {
    CASINO_GAMING_BALANCE: 'casino_gaming_balance',
    TOTAL_BONUS_BALANCE: 'total_bonus_balance',
    REAL_GAMING_BALANCE: 'real_gaming_balance',
    TOTAL_FREE_SPINS_BALANCE: 'free_spin_balance',
    FREE_SPIN_BALANCE: 'free_spin_balance',
    WITHDRAWABLE_BALANCE: 'withdrawable_balance',
    BONUS_BALANCE: 'bonus_balance',
    RINGFENCED_REAL_BALANCE: 'ringfenced_real_balance',
    BONUS_PENDING_WINNINGS: 'bonus_pending_winnings'
};
